import {
  Component,
  OnInit
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators
} from '@angular/forms';
import {
  GlobalService
} from 'src/app/services/global.service';

@Component({
  selector: 'app-external-analysis',
  templateUrl: './external-analysis.component.html',
  styleUrls: ['./external-analysis.component.scss']
})
export class ExternalAnalysisComponent implements OnInit {
  extranlForm: FormGroup;
  public openForm: boolean = false;
  constructor(public fb: FormBuilder, public globalService: GlobalService) {
    this.extranlForm = this.fb.group({
      name: [null, Validators.required],
      name_select_name: [null, Validators.required],
      type: [null, Validators.required],
      type_select_name: [null, Validators.required],
    })
  }
  public frameUrl: String = "";
  ngOnInit() {

  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.globalService.externalAnalysisList && this.globalService.externalAnalysisList.length > 0 && this.globalService.externalAnalysisType && this.globalService.externalAnalysisType.length > 0) {
        this.extranlForm.patchValue({
          'name': this.globalService.externalAnalysisName[0]['id'],
          'type': this.globalService.externalAnalysisType[0]['id']
        });
      }
    }, 1000);
  }
  public changeSelection(selectedValue): void {
    setTimeout(() => {
      let option = selectedValue['fieldName'];
    }, 0);
  }

  public submitForm() {
    let obj = {
      name: this.extranlForm['controls']['name']['value'],
      type: this.extranlForm['controls']['type']['value']
    }
    for (let val of this.globalService.externalAnalysisList) {
      if (val['name'] == obj['name'] && val['data']['type'] == obj['type']) {
        this.frameUrl = val['url'];
        break;
      }
    }
  }

}
